import React from 'react';
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  ToggleButton,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers-pro';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';

const LocationLogsSettingsCard = ({
  techs,
  setTech,
  setTextSearch,
  setFilterDate,
  filter,
  onButtonClick,
  viewConnections,
  setViewConnections,
}) => {
  const {
    techsGHSCInstruction,
    techsGHSCTech,
    techsGHSCPeriod,
    techsGHSCPStart,
    techsGHSCPEnd,
    techsGHSCTodayP,
    techsGHSCConfirm,
  } = useTranslationHook();

  // Set both dates to today
  const setToToday = () => {
    const todayStart = moment().startOf('day');
    const todayEnd = moment().endOf('day');
    setFilterDate({
      startDate: todayStart,
      endDate: todayEnd,
    });
  };

  return (
    <Box>
      <Box className='settingHistory'>
        <Box className='instruction'>{techsGHSCInstruction}</Box>

        <Autocomplete
          disablePortal
          options={techs}
          getOptionLabel={(techs) => techs.name + ' ' + techs.last_name}
          isOptionEqualToValue={(techs, value) => techs.id === value.id}
          renderInput={(params) => (
            <TextField {...params} placeholder={techsGHSCTech} />
          )}
          onChange={(event, newValue) => {
            setTech(newValue);
          }}
          onInputChange={(event, value) => {
            setTextSearch(value);
          }}
        />
      </Box>

      <Box className='dateContainer'>
        <Box>
          <Box className='instruction'>{techsGHSCPeriod}</Box>
          <Box className='datePicker'>
            <DatePicker
              sx={{ width: '100%' }}
              value={filter.startDate}
              onChange={(selectedDate) => {
                setFilterDate({
                  startDate: moment(selectedDate).startOf('day'),
                  endDate: moment(selectedDate).endOf('day'),
                });
              }}
            />
          </Box>
        </Box>

        <Box display='flex' justifyContent='space-between' width={'100%'}>
          <ToggleButton
            value='check'
            selected={viewConnections}
            onChange={() => {
              setViewConnections(!viewConnections);
            }}
          >
            <RouteOutlinedIcon />
          </ToggleButton>
          <Button onClick={setToToday}>{techsGHSCTodayP}</Button>
          <Button onClick={onButtonClick}>{techsGHSCConfirm}</Button>
        </Box>
      </Box>
    </Box>
  );
};

export default LocationLogsSettingsCard;
